import React, { useState } from "react";
import { BackgroundImage } from "../Media";
import { ISearchContext, useSearch } from "./SearchContext";
import { EWsrvTransform } from "../../lib/Media/util";

export interface ILiveFiltersProps {
  className?: string;
  formClassName?: string;
  primaryFilters?: (context: ISearchContext) => React.ReactNode;
  secondaryFilters?: (context: ISearchContext) => React.ReactNode;
  alternateFilters?: (context: ISearchContext) => React.ReactNode;
  hideAlternateFilters?: boolean;
  showAdvancedText?: string;
  hideAdvancedText?: string;
  formBackgroundImage?: string;
  title?: string
}

export const LiveFilters: React.FC<ILiveFiltersProps> = ({
  className,
  primaryFilters,
  secondaryFilters,
  alternateFilters,
  hideAlternateFilters,
  showAdvancedText,
  hideAdvancedText,
  formBackgroundImage,
  title,
  formClassName,
}) => {
  const context = useSearch();

  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false)

  const showAdvancedFilterText = showAdvancedText ?? "Advanced Search"
  const hideAdvancedFilterText = hideAdvancedText ?? "Close Advanced Search"

  const onClickHandler = () => {
    setShowAdvancedFilter(!showAdvancedFilter)
  }

  const sizesAndAspect = [
    {
      width: 420,
      aspect: EWsrvTransform.cover2x6,
    },
    {
      media: "min-width:420px",
      width: 640,
      aspect: EWsrvTransform.cover2x6,
    },
    {
      media: "min-width:640px",
      width: 768,
      aspect: EWsrvTransform.cover3x2,
    },
    {
      media: "min-width:768px",
      width: 1024,
      aspect: EWsrvTransform.cover3x2,
    },
    {
      media: "min-width:1024px",
      width: 1280,
      aspect: EWsrvTransform.cover16x9,
    },
    {
      media: "min-width:1280px",
      width: 1440,
      aspect: EWsrvTransform.cover16x9,
    },
    {
      media: "min-width:1440px",
      width: 1920,
      aspect: EWsrvTransform.cover16x9,
    },
    {
      media: "min-width:1920px",
      width: 2560,
      aspect: EWsrvTransform.cover16x9,
    },
  ]

  let liveFilters = (
    <>
      <fieldset className={`p-2 ${className} ${showAdvancedFilter ? "expanded" : ""}`}>
        {title && (
          <h1 className="search-title">{title}</h1>
        )}
        <form
          className={`flex flex-wrap gap-5 md:gap-10 max-w-screen-xl mx-auto search-filters ${formClassName}`}
        >
          {primaryFilters && (
            <div className={`gap-5 sm:grid-flow-row sm:grid-cols-2 lg:grid-cols-4 my-3 w-full search-filters-primary ${hideAlternateFilters && showAdvancedFilter ? "hidden" : "grid"}`}>
              {primaryFilters(context)}
            </div>
          )}
          {secondaryFilters && (
            <div className={`gap-3 flex-col justify-between w-full md:w-1/3 my-3 search-filters-secondary ${hideAlternateFilters && showAdvancedFilter ? "hidden" : "flex"}`}>
              {secondaryFilters(context)}
            </div>
          )}
          {alternateFilters && (
            <div className={`my-3 grow search-filters-alternate self-end ${hideAlternateFilters && !showAdvancedFilter ? "hidden" : ""}`}>
              {alternateFilters(context)}
            </div>
          )}
        </form>
        {hideAlternateFilters && (
          <div className="w-full flex flex-row justify-center items-center text-inherit search-mode-toggle">
            <input className="cursor-pointer" type="button" onClick={onClickHandler} value={showAdvancedFilter ? hideAdvancedFilterText : showAdvancedFilterText} />
          </div>
        )}
      </fieldset>
    </>
  )

  formBackgroundImage && (
    liveFilters = (<BackgroundImage sizesAndAspect={sizesAndAspect} className="search-bg-image" src={formBackgroundImage}>
      {liveFilters}
    </BackgroundImage>)
  )

  return (
    <>{liveFilters}</>
  );
};

export default LiveFilters;
